export default {
    viewDirection: '',
    wechatSignUrl: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js